import { PopupConfig} from './PopupConfig';
import { PopupIds } from './PopupIds';
import { PopupConfigData } from './popup-config-data';

export class PopupOpenConfigStorage {
    private configs: { [key: string]: PopupConfigData } = {
        [PopupIds.REGISTRATION]: {
            alignoff: true
        },
        [PopupIds.RESTORE_PASS]: {
            alignoff: true
        },
        [PopupIds.NEW_PASS]: {
            alignoff: true
        },
        [PopupIds.LOGIN]: {
            alignoff: true
        },
        [PopupIds.OTP_REQUEST_CODE]: {
            alignoff: true
        },
        [PopupIds.OTP_LOGIN]: {
            alignoff: true
        },
        [PopupIds.ACCOUNT_MANAGEMENT]: {
            alignoff: true,
            firstInputFocus: false
        },
        [PopupIds.EULA_POLICY]: {
            url: 'policies/eula_policy'
        },
        [PopupIds.PAYMENT_POLICY]: {
            url: 'policies/payment_policy'
        },
        [PopupIds.PRIVACY_POLICY]: {
            url: 'policies/privacy_policy'
        },
        [PopupIds.REFUND_POLICY]: {
            url: 'policies/refund_policy'
        },
        [PopupIds.TERMS_OF_SERVICE]: {
            url: 'policies/terms_of_service'
        }
    };


    public getPopupOpenConfig = (popupId: string) => {
        let config: PopupConfigData;

        if (this.configs[popupId]) {
            config = this.configs[popupId];
            config.id = popupId;
            return config;
        }

        return this.getDefaultConfig(popupId);
    };

    public getDefaultConfig = (popupId: string) => {
        const config = new PopupConfig(null);

        config.id = popupId;

        return config;
    };
}

export default new PopupOpenConfigStorage();
